/**
 * === CUSTOM: bulletproof-scroll-lock ===
 *
 * Stretch laser baggrundssiden med `html.lock { overflow: hidden }`, hvilket
 * ikke holder paa iOS Safari (touch-scroll og rubber-banding slipper igennem,
 * saa drawer-headeren kan scrolles vaek).
 *
 * Dette script haenger sig paa temaets eksisterende `lock`-klasse (allerede
 * reference-taellet i DialogElement) og laaser i stedet via `position: fixed`
 * paa <body> med bevaret scroll-position. Det er den iOS-sikre teknik.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  var isLocked = false;
  var savedScrollY = 0;

  function lock() {
    if (isLocked) {
      return;
    }
    isLocked = true;
    savedScrollY = window.scrollY || window.pageYOffset || 0;

    body.style.position = 'fixed';
    body.style.top = '-' + savedScrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
  }

  function unlock() {
    if (!isLocked) {
      return;
    }
    isLocked = false;

    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';

    // Genskab scroll-positionen uden smooth-animation.
    var previousScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedScrollY);
    root.style.scrollBehavior = previousScrollBehavior;
  }

  function sync() {
    if (root.classList.contains('lock')) {
      lock();
    } else {
      unlock();
    }
  }

  var observer = new MutationObserver(sync);
  observer.observe(root, { attributes: true, attributeFilter: ['class'] });

  // Haandter en drawer der allerede er aaben ved script-load.
  sync();
})();
